<script>
import baseList from "@/views/components/base/baseList.vue";
import { Poptip, Button } from "view-design";
import SysLogList from "../../log/uplog/list.vue";
let customerId = window.localStorage.getItem("customerId");
export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "role",
        key: "roleId",
        url: {
          del: "/admin/system/role",
        },
      },
      actions: [
        {
          label: "新增",
          icon: "md-add",
          type: "info",
          onClick: this.toAdd,
          auth: "admin/authgroup/add",
        },
      ],
      tactions: [],
      menus: [
        {
          label: "后台权限",
          name: "auth_group_list",
          auth: "",
        },
        {
          label: "用户权限",
          name: "weapp_client_list_item",
          auth: "",
          show: window.localStorage.getItem("customerId") != 0 ? false : true,
        },
        {
          label: "维修权限",
          name: "weapp_engineer_list_item",
          auth: "",
          show: window.localStorage.getItem("customerId") != 0 ? false : true,
        },
        // {
        //   label: "用户权限",
        //   name: "auth_access_list",
        //   auth: "/admin/authaccess/lists",
        // },
        // {
        //   label: "角色权限",
        //   name: "auth_group_list",
        //   auth: "/admin/authgroup/lists",
        // },
        // {
        //   label: "权限规则",
        //   name: "auth_rule_list",
        //   auth: "/admin/authrule/lists",
        // },
      ],
      query: {},
      // filters: [{ label: '权限组名', name: 'name', value: '', type: 'input' }],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "名称",
          key: "roleName",
          minWidth: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            let colorStr =
              row.roleKey == "zhuguanquanxian" ||
              row.roleKey == "gongchengshiquanxian" ||
              row.roleKey == "yonghuquanxian"
                ? "#939393"
                : "#515a6e";
            return h(
              "span",
              {
                style: {
                  color: colorStr,
                },
              },
              row.roleName
            );
          },
        },
        {
          title: "状态",
          align: "center",
          key: "status",
          width: 100,
          render: (h, params) => {
            const row = params.row;
            const color =
              row.status == 0 ? "blue" : row.status == 1 ? "red" : "";
            const text =
              row.status == 0 ? "正常" : row.status == 1 ? "停用" : "";
            return h(
              "span",
              {
                style: {
                  "font-size": "14px",
                  color: color,
                },
              },
              text
            );
          },
        },
        {
          title: "绑定角色",
          align: "center",
          key: "status",
          minWidth: 200,
          render: (h, params) => {
            const row = params.row;
            let arr = [];
            row.userList.forEach((item) => {
              arr.push(item.nickName);
            });
            const arrStr = arr.length > 0 ? arr.join() : "";
            return h(
              "span",
              {
                style: {
                  "font-size": "14px",
                },
              },
              arrStr
            );
          },
        },
        {
          title: "备注",
          key: "remark",
          width: 100,
          align: "center",
        },
        // {
        //   title: "更新时间",
        //   key: "updateTime",
        //   width: 115,
        //   align: "center",
        //   render: (h, params) => {
        //     const row = params.row;
        //     const text = row.updateTime.slice(0, 16);
        //     return <span>{text}</span>;
        //   },
        // },
        {
          title: "操作",
          align: "center",
          width: 230,
          key: "handle",
          handle: [
            // (vm, h, currentRow, param) => {
            //   return (
            //     <Button type="success" size="small" onClick={this.logRecord.bind(this, currentRow)} style={{ margin: '4px 5px' }}>
            //       操作日志
            //     </Button>
            //   )
            // },
            (vm, h, currentRow, param) => {
              return h(
                "div",
                {
                  style: {
                    marginLeft: "5px",
                    display: "inline-block",
                  },
                  on: {
                    click: () => {
                      this.handleSelectUser(currentRow);
                    },
                  },
                },
                [
                  h(
                    "Button",
                    {
                      props: {
                        size: "small",
                        type: "default",
                        placement: "top",
                      },
                      style: {
                        border: "none",
                        margin: "4px 0px",
                        color: "#4991ff",
                      },
                    },
                    "添加人员"
                  ),
                ]
              );
            },
            (vm, h, currentRow, param) => {
              if (
                !currentRow.isProtected ||
                customerId == 0 ||
                $utils.data.get("auth", "isAdmin") == 1
              ) {
                return h(
                  "div",
                  {
                    style: {
                      marginLeft: "5px",
                      display: "inline-block",
                    },
                    on: {
                      click: () => {
                        this.handleEdit(currentRow);
                      },
                    },
                  },
                  [
                    h(
                      "Button",
                      {
                        props: {
                          size: "small",
                          type: "default",
                          placement: "top",
                        },
                        style: {
                          border: "none",
                          margin: "4px 0px",
                          color: "#4991ff",
                        },
                      },
                      "编辑"
                    ),
                  ]
                );
              }
            },
            // "delete",
            (vm, h, currentRow, param) => {
              if (
                !currentRow.isProtected ||
                customerId == 0 ||
                $utils.data.get("auth", "isAdmin") == 1
              ) {
                return h(
                  "Poptip",
                  {
                    props: {
                      confirm: true,
                      title: "确定要删除这条数据吗?",
                      transfer: true,
                    },
                    on: {
                      "on-ok": () => {
                        vm.handleDel(currentRow);
                      },
                    },
                  },
                  [
                    h(
                      "div",
                      {
                        style: {
                          marginLeft: "5px",
                          display: "inline-block",
                        },
                      },
                      [
                        h(
                          "Button",
                          {
                            props: {
                              size: "small",
                              type: "default",
                              placement: "top",
                            },
                            style: {
                              border: "none",
                              margin: "4px 0px",
                              color: "#4991ff",
                            },
                          },
                          "删除"
                        ),
                      ]
                    ),
                  ]
                );
              }
            },
          ],
          auth: {
            edit: "admin/authgroup/edit",
            // del: "admin/authgroup/delete",
          },
        },
      ],
      userListAll: [],
      selectUser: [],
    };
  },
  created() {
    this.loadUserList();
  },
  methods: {
    toAdd() {
      $utils.url.push({ name: "auth_group_add", query: { action: "add" } });
    },
    async loadUserList() {
      let q = {};
      let res = await $utils.api.load(
        "/admin/system/user/selectUserOptions",
        q,
        "get"
      );
      if (res.code == 200) {
        this.userListAll = res.data;
      }
    },
    handleSelectUser(row) {
      let arr = [];
      row.userList.forEach((item) => {
        arr.push(item.userId);
      });
      this.selectUser = arr;
      this.$Modal.success({
        title: "添加人员",
        width: "900px",
        showOk: false,
        closable: true,
        render: (h) => {
          return (
            <div>
              <div style="display:flex;align-items:center; margin:10px 0 20px 0;">
                <div style="width:100px;">请选择人员：</div>
                <Select vModel={this.selectUser} filterable multiple>
                  {this.userListAll.map((item) => {
                    return <Option value={item.userId}>{item.nickName}</Option>;
                  })}
                </Select>
              </div>
              <Button
                type="primary"
                onClick={() => {
                  this.submitSelectUser(row);
                }}
              >
                确定
              </Button>
            </div>
          );
        },
      });
      //
      // $utils.url.push({
      //   name: "auth_group_edit",
      //   query: { action: "edit", kv: row.roleId },
      // });
    },
    submitSelectUser(row) {
      let q = {
        roleId: row.roleId,
        userIds: this.selectUser,
      };
      $utils.api
        .load("/admin/system/role/authUser/selectAll", q, "put")
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.$Modal.remove();
            this.search();
          }
        });
    },
    handleEdit(row) {
      $utils.url.push({
        name: "auth_group_edit",
        query: { action: "edit", kv: row.roleId },
      });
    },
    handleDel(row) {},
    logRecord(row) {
      this.$Modal.info({
        title: "操作日志",
        width: "900px",
        showOk: false,
        render: (h) => {
          return (
            <SysLogList
              style={{ margin: "0", color: "#19be6b" }}
              table_name={"auth_group"}
              table_key={row.id}
            ></SysLogList>
          );
        },
      });
    },
  },
};
</script>
